import React from "react";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";

interface DateRangeInputsProps {
  startLabel: string;
  endLabel: string;
  minDate?: string;
  maxDate?: string;
  startRegister?: UseFormRegisterReturn;
  endRegister?: UseFormRegisterReturn;
  errors?: {
    start?: FieldError;
    end?: FieldError;
  };
  className?: string;
}

export function DateRangeInputs({
  startLabel,
  endLabel,
  minDate,
  maxDate,
  startRegister,
  endRegister,
  errors,
  className = "",
}: DateRangeInputsProps) {
  return (
    <div className={`grid grid-cols-2 gap-4 ${className}`}>
      <div>
        <label className="block text-gray-bb-1 font-medium mb-2">
          {startLabel}
        </label>
        <input
          {...startRegister}
          type="date"
          min={minDate}
          max={maxDate}
          className={`w-full border rounded-lg p-3 focus:ring-2 focus:ring-blue-bb focus:border-transparent ${
            errors?.start ? "border-red-500" : "border-gray-bb-4"
          }`}
        />
        {errors?.start && (
          <p className="text-red-500 text-sm mt-1">{errors.start.message}</p>
        )}
      </div>

      <div>
        <label className="block text-gray-bb-1 font-medium mb-2">
          {endLabel}
        </label>
        <input
          {...endRegister}
          type="date"
          min={minDate}
          max={maxDate}
          className={`w-full border rounded-lg p-3 focus:ring-2 focus:ring-blue-bb focus:border-transparent ${
            errors?.end ? "border-red-500" : "border-gray-bb-4"
          }`}
        />
        {errors?.end && (
          <p className="text-red-500 text-sm mt-1">{errors.end.message}</p>
        )}
      </div>
    </div>
  );
}